import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import UserAvatar from '~/modules/common/components/Avatars/UserAvatar/UserAvatar';
import RoleScheduleWithTooltip from './RoleScheduleWithTooltip';

const useStyles = makeStyles(theme => ({
  root: { display: 'flex', alignItems: 'center' },
  avatar: {
    flexGrow: 0,
    flexShrink: 0,
    width: theme.spacing(4),
    height: theme.spacing(4),
    fontSize: theme.typography.caption.fontSize
  },
  rows: {
    flexGrow: 1,
    flexShrink: 1,
    padding: theme.spacing(0, 0, 0, 1),
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    overflow: 'hidden'
  },
  row: {
    flexGrow: 0,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...theme.typography.caption,
    lineHeight: `${theme.spacing(2)}px`,
    width: 128
  },
  nameRow: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold
  }
}));

export const UserWithRoleSchedules = ({ classes: classesOverride, user }) => {
  const classes = useStyles({ classes: classesOverride });

  return (
    <div className={classes.root}>
      <UserAvatar user={user} size="small" className={classes.avatar} />
      <div className={classNames(classes.rows, classes.row, classes.nameRow)}>
        {user.displayText}
        {user.roleSchedulesAsOfDate && (
          <RoleScheduleWithTooltip
            roleScheduleAsOfDate={
              user.roleSchedulesAsOfDate.effectiveRoleSchedule
            }
          />
        )}
      </div>
    </div>
  );
};

UserWithRoleSchedules.propTypes = {
  classes: PropTypes.object,
  user: PropTypes.shape({
    displayText: PropTypes.string.isRequired,
    roleSchedulesAsOfDate: PropTypes.object
  })
};

export default UserWithRoleSchedules;
